<a
                href="{{url}}"
                target="_blank"
                class="fa-stack">
                <i class="fab fa-facebook-f fa-stack-1x"></i>
            </a>